/**
 * Mandatory fields configuration (matches 1.0 form_macros-tailwind.html lines 1-81)
 * These fields MUST be filled for valid submission
 */
export const MANDATORY_FIELDS = [

  //Malaysia Taxonomy
      'ssmt-dei:NewCompanyRegistrationNumber',
      'ssmt-dei:NameOfReportingEntity',
      'ssmt-dei:OriginOfCompany',
      'ssmt-dei:StatusOfCompany',
      'ssmt-dei:TypeOfCompany',
      'ssmt-dei:ApplicationOfSubmission',
      'ssmt-dei:DisclosureOfFinancialStatementsPreparationForCurrentSubmission',
      'ssmt-dei:CompanyCurrentFinancialYearStartDate',
      'ssmt-dei:CompanyCurrentFinancialYearEndDate',
      'ssmt-dei:StatusOfCarryingOnBusinessDuringFinancialYear',
      'ssmt-dei:DisclosureOfFinancialStatementsAuditStatus',
      'ssmt-dei:BasisOfAccountingStandardsAppliedToPrepareFinancialStatements',
      'ssmt-dei:TypeOfSubmission',
      'ssmt-dei-ee-mfrs:NatureOfFinancialStatements',
      'ssmt-dei-ee-mpers:NatureOfFinancialStatements',
      'ssmt-dei:DescriptionOfPresentationCurrency',
      'ssmt-dei:LevelOfRoundingUsedInFinancialStatements',
      'ssmt-dei:NameAndVersionOfSoftwareUsedToGenerateXBRLFile',
      'ssmt-dei:TaxonomyVersion',
      
      'ssmt:DateOfFinancialStatementsApprovedByBoardOfDirectors',
      'ssmt:DateOfCirculationOfFinancialStatementsAndReportsToMembers',
      'ssmt:DateOfStatutoryDeclaration',
      'ssmt:DisclosureOnWhetherComparativePeriodValuesAreRestated',
      'ssmt:DisclosureOnWhetherOpeningStatementChangedDueToChangesInAccountingStandards',
      'ssmt:DisclosureOnWhetherReclassificationOfPreviousFinancialStatementsChangedDueToChangesInAccountingStandards',
      'ssmt:DisclosureOnWhetherCompanyChangedDurationOfFinancialReportingPeriod',
      
      'ssmt:DisclosureOfDirectorsReportExplanatory',
      'ssmt:NumberOfDirectorsSigningDirectorsReport',
      'ssmt:NameOfFirstDirectorWhoSignedDirectorsReport',
      'ssmt:TypeOfIdentificationOfFirstDirectorWhoSignedDirectorsReport',
      'ssmt:IdentificationNumberOfFirstDirectorWhoSignedDirectorsReport',
      'ssmt:DisclosureOfStatusOfDividend',
      'ssmt:DisclosureOfContingentOrOtherLiabilityBeingEnforceableWithinTwelveMonthsAfterEndOfFinancialYear',
      'ssmt:DisclosureOfOccurenceOfAnySubstantialMaterialOrUnusualInNatureItemsTransactionsOrEvents',
      'ssmt:DisclosureOfDirectorsReceivedOrBecomeEntitledToReceiveOtherBenefitsByReasonOfContractMadeByCompanyOrRelatedCorporation',
      'ssmt:DateOfSigningDirectorsReport',
      
      'ssmt:DisclosureOfStatementByDirectorsExplanatory',
      'ssmt:DisclosureOfDirectorsOpinionThatFinancialStatementsOrConsolidatedFinancialStatementsAreDrawnInAccordanceWithAccountingStandards',
      'ssmt:NumberOfDirectorsSigningStatementByDirectors',
      'ssmt:NameOfFirstDirectorWhoSignedStatementByDirectors',
      'ssmt:DisclosureWhetherFirstDirectorIsAlsoPrimarilyResponsibleForFinancialManagementOfCompany',
      'ssmt:TypeOfIdentificationOfFirstDirectorWhoSignedStatementByDirectors',
      'ssmt:IdentificationNumberOfFirstDirectorWhoSignedStatementByDirectors',
      'ssmt:DateOfSigningStatementByDirectors',
      
      'ssmt:NumberOfEmployees',
      
      'ssmt:DisclosureOfAuditorsReportToMembersExplanatory',
      'ssmt:TypeOfAuditorsOpinion',
      'ssmt:DateOfSigningAuditorsReport',
      'ssmt:LicenseNumberOfAuditor',
      'ssmt:RegistrationNumberOfAuditFirm',
      'ssmt:AddressOne',
      'ssmt:PostcodeOfAuditFirm',
      'ssmt:TownWhereAuditFirmIsLocated',
      'ssmt:StateWhereAuditFirmIsLocated',

      // CLBS 1965
      'ssmt-1965:TypeOfAuditorsOpinion',
      'ssmt-1965:RegistrationNumberOfAuditFirm',
      'ssmt-1965:NameOfAuditFirm',
      'ssmt-1965:AddressOfAuditFirm',
      'ssmt-dei-1965:NewCompanyRegistrationNumber',
      'ssmt-dei-1965:NameOfReportingEntity',
      'ssmt-dei-1965:OriginOfCompany',
      'ssmt-dei-1965:StatusOfCompany',
      'ssmt-dei-1965:TypeOfCompany',
      'ssmt-dei-1965:ApplicationOfSubmission',
      'ssmt-dei-1965:TypeOfSubmission',
      'ssmt-dei-1965:FinancialYear',
      'ssmt-dei-1965:DisclosureOfFinancialStatementsPreparationForCurrentSubmission',
      'ssmt-dei-1965:CompanyCurrentFinancialYearStartDate',
      'ssmt-dei-1965:CompanyCurrentFinancialYearEndDate',
      'ssmt-dei-1965:CompanyPreviousFinancialYearStartDate',
      'ssmt-dei-1965:CompanyPreviousFinancialYearEndDate',
      'ssmt-dei-1965:DateOfCirculationOfFinancialStatementsAndReportsToMembers',
      'ssmt-dei-1965:NatureOfFinancialStatements',
      'ssmt-dei-1965:LevelOfRoundingUsedInFinancialStatements',
      'ssmt-dei-1965:MethodUsedForPreparingStatementsOfFinancialPosition',
      'ssmt-dei-1965:DescriptionOfPresentationCurrency',
      'ssmt-dei-1965:NameAndVersionOfSoftwareUsedToGenerateXBRLFile',
      'ssmt-dei-1965:TaxonomyVersion',



  //Singapore Taxonomy
      // Filing info
      'sg-dei:NameOfCompany',
      'sg-dei:UniqueEntityNumber',
      'sg-dei:TypeOfXBRLFiling',
      'sg-dei:NatureOfFinancialStatementsCompanyLevelOrConsolidated',
      'sg-dei:TypeOfAccountingStandardUsedToPrepareFinancialStatements',
      'sg-dei:TypeOfStatementOfFinancialPosition',
      'sg-dei:WhetherFinancialStatementsArePreparedOnGoingConcernBasis',
      'sg-dei:DescriptionOfPresentationCurrency',
      'sg-dei:LevelOfRoundingUsedInFinancialStatements',
      'sg-dei:CurrentPeriodStartDate',
      'sg-dei:CurrentPeriodEndDate',
      'sg-dei:PriorPeriodStartDate',
      'sg-dei:DateOfAuthorisationForIssueOfFinancialStatements',
      'sg-dei:TaxonomyVersion',
      'sg-dei:NameAndVersionOfSoftwareUsedToGenerateInstanceDocument',
      'sg-dei:HowWasXBRLInstanceDocumentPrepared',

      // mandatory_039
      'sg-as:DisclosureOfCompleteSetOfFinancialStatementsTextBlock',

      // Mandatory_041-043 (use CashFlows*, not NetCashFlows*)
      'sg-as:CashFlowsFromUsedInOperatingActivities',
      'sg-as:CashFlowsFromUsedInInvestingActivities',
      'sg-as:CashFlowsFromUsedInFinancingActivities',


      //Additional Information
      'sg-as:NumberOfEmployeesOfCompany',
      'sg-as:NumberOfEmployeesOfGroup',
      'sg-as:WhetherCompanyIsSubsidiary',
      'sg-as:WhetherCompanyHasAnySubsidiaryAssociateOrJointVenture'
];

/**
 * Field codes for exemption applications (matches 1.0 form_macros-tailwind.html lines 71-81)
 */
export const FIELD_CODES: Record<string, string> = {
  'ssmt:DescriptionOnWhetherCompanyHadAppliedForExemptionFromCoincidingForeignSubsidiaryFinancialYearEndWithHoldingCompany': 'EA1',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedFromFilingFinancialStatementsAndReportsInFullXBRLFormat': 'EA2',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedToWaiveLodgementOfForeignStatementsByForeignCompany': 'EA3',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedForReliefFromRequirementsAsToFormAndContentsOfDirectorsReport': 'EA4A',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedForReliefFromRequirementsAsToFormAndContentsOfFinancialStatements': 'EA4B',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeForCirculationOfFinancialStatementsAndReports': 'EA5A',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeToLodgeFinancialStatementsAndReports': 'EA5B',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeForHoldingAnnualGeneralMeeting': 'EA6',
  'ssmt:DescriptionOnWhetherCompanyHadAppliedForExtensionOfTimeToLodgeAnnualReturn': 'EA7'
};

/**
 * Check if a field is mandatory
 */
export const isMandatoryField = (qname: string): boolean => {
  return MANDATORY_FIELDS.includes(qname);
};

/**
 * Get field code if exists
 */
export const getFieldCode = (qname: string): string | undefined => {
  return FIELD_CODES[qname];
};


